import { FunctionComponent } from 'react';
import Alert from '../../../../../../components/Alert';
import styles from '../../styles.module.scss';
import AddEducatorReviewLink from '../../../../../../components/AddEducatorReviewLink';
import { PublicEducator } from '@cademy-package/sdk-component-types';

export const EmptyReviewsAlert: FunctionComponent<{ educator: PublicEducator }> = ({
    educator,
}) => {
    return (
        <Alert preset="info">
            <div className={styles.emptyPlaceholder}>
                There are no reviews for {educator.name} yet. Why not be the first one?&nbsp;
                <AddEducatorReviewLink educatorSlug={educator.slug}>
                    Add Review
                </AddEducatorReviewLink>
            </div>
        </Alert>
    );
};
